import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import CLocalizedTextString from '../../components/CLocalizedTextString';
import { PageRoutes } from '../../enums/enums';
import { useAppDispatch } from '../../hooks/hooks';
import { addBreadcrumbTextReplacement, purgeBreadcrumbTextReplacementDictForOutlets } from '../../store/appSlice';

export default function PUserTrackingOutlet() {
  const dispatch = useAppDispatch();
  const usageTrackingTitle = CLocalizedTextString('usageTracking.title');
  useEffect(() => {
    dispatch(addBreadcrumbTextReplacement([PageRoutes.USAGE_TRACKING_OUTLET, usageTrackingTitle]));

    return () => {
      dispatch(purgeBreadcrumbTextReplacementDictForOutlets());
    };
  }, [dispatch,usageTrackingTitle]);
  return <Outlet />;
}